/**
 * UAVTradeZone Modification Record
 *
 * Change ID:    BROADCASTS_FILTER_INTEGRATION
 * Date:         2026-01-01
 * Modified By:  Cursor
 *
 * Description:
 * Custom hook for broadcast filter state management.
 * Extracted from useBroadcastsList to maintain file size limits.
 *
 * File Size Check:
 * - New file
 * - Projected: ~80 lines
 * - Decision: Proceed (within 100-line hook limit)
 *
 * Related Screens / Modules:
 * - client/src/features/broadcast/pages/broadcasts-list/hooks/useBroadcastFilters.ts (NEW)
 * - client/src/features/broadcast/pages/broadcasts-list/hooks/useBroadcastsList.ts
 */

import { useState } from "react";

export const useBroadcastFilters = () => {
  // [2026-01-01] Broadcast filter state
  const [broadcastFilterKeyword, setBroadcastFilterKeyword] = useState("");
  const [broadcastSKU, setBroadcastSKU] = useState("");
  const [broadcastType, setBroadcastType] = useState("");
  const [broadcastManufacturer, setBroadcastManufacturer] = useState("");
  const [broadcastCategory, setBroadcastCategory] = useState("");
  const [broadcastQty, setBroadcastQty] = useState(0);
  const [broadcastCondition, setBroadcastCondition] = useState("");
  const [broadcastCountry, setBroadcastCountry] = useState("");
  const [broadcastCompany, setBroadcastCompany] = useState("");

  // [2026-01-01] Filter change handler
  const handleFilterChange = (field: string, value: any) => {
    switch (field) {
      case "broadcastFilterKeyword":
        setBroadcastFilterKeyword(value);
        break;
      case "broadcastSKU":
        setBroadcastSKU(value);
        break;
      case "broadcastType":
        setBroadcastType(value);
        break;
      case "broadcastManufacturer":
        setBroadcastManufacturer(value);
        break;
      case "broadcastCategory":
        setBroadcastCategory(value);
        break;
      case "broadcastQty":
        setBroadcastQty(value);
        break;
      case "broadcastCondition":
        setBroadcastCondition(value);
        break;
      case "broadcastCountry":
        setBroadcastCountry(value);
        break;
      case "broadcastCompany":
        setBroadcastCompany(value);
        break;
    }
  };

  // [2026-01-01] Clear all filters
  const handleClearFilters = () => {
    setBroadcastFilterKeyword("");
    setBroadcastSKU("");
    setBroadcastType("");
    setBroadcastManufacturer("");
    setBroadcastCategory("");
    setBroadcastQty(0);
    setBroadcastCondition("");
    setBroadcastCountry("");
    setBroadcastCompany("");
  };

  return {
    broadcastFilterKeyword,
    broadcastSKU,
    broadcastType,
    broadcastManufacturer,
    broadcastCategory,
    broadcastQty,
    broadcastCondition,
    broadcastCountry,
    broadcastCompany,
    handleFilterChange,
    handleClearFilters,
  };
};
